import React from 'react';
import AppView from '@common/components/app-view';
import { AllocatedPhoneNumbers } from './allocated-phone-numbers';

const AllocatedPhoneNumbersPage = () => {
  return (
    <AppView title="WhatsApp Numbers" activeExtensionView="whatsapp-numbers" showHeader={false}>
      <AllocatedPhoneNumbers />
    </AppView>
  );
};

export default AllocatedPhoneNumbersPage; 